import * as actions from "../actions";
import * as api from "../../api";
import { pushSourceToken } from 'utils';


export const getEventStatsDataTable = (params = {}) => {
  return (dispatch, getState) => {
    let sourceToken = pushSourceToken("GET_DATA_TABLE_EVENT_STATS", dispatch);
    const {token} = getState().auth;
    return dispatch(actions.getEventStatsDataTable(api.getEventStatsDataTable(token,params, sourceToken)));
  };
};


export const countEventAppType = (params = {}) => {
  return (dispatch, getState) => {
    let sourceToken = pushSourceToken("COUNT_EVENT_STATS_APP_TYPE", dispatch);
    const {token} = getState().auth;
    return dispatch(actions.countEventAppType(api.countEventAppType(token,params, sourceToken)));
  };
};

export const getGlobalEventStats = (params = {}) => {
  return (dispatch, getState) => {
    let sourceToken = pushSourceToken("GET_GLOBAL_EVENT_STATS", dispatch);
    const {token} = getState().auth;
    return dispatch(actions.getGlobalEventStats(api.getGlobalEventStats(token,params, sourceToken)));
  };
};


export const getSeasonsValues = (params = {}) => {
  return (dispatch, getState) => {
    let sourceToken = pushSourceToken("GET_SEASONS_VALUES", dispatch);
    const {token} = getState().auth;
    return dispatch(actions.getSeasonsValues(api.getSeasonsValues(token,params, sourceToken)));
  };
};


export const fetchRegistrantLineChartData = (frequency, period, languages, isComparison = 0, isComparisonDaily = 0) => {
  return (dispatch, getState) => {
    let sourceToken = pushSourceToken("GET_DATA_CHART_EVENT_STATS", dispatch);
    const {token, currentClient} = getState().auth;
    return api.fetchRegistrantLineChartData(token, currentClient.id, frequency, period, languages, sourceToken, isComparison, isComparisonDaily);
  };
};

export const fetchRegistrantLineChartCAData = (frequency, period, languages, isComparison = 0, isComparisonDaily = 0) => {
  return (dispatch, getState) => {
    let sourceToken = pushSourceToken("GET_CA_DATA_CHART_EVENT_STATS", dispatch);
    const {token, currentClient} = getState().auth;
    return api.fetchRegistrantLineChartCAData(token, currentClient.id, frequency, period, languages, sourceToken, isComparison, isComparisonDaily);
  };
};

export const fetchCongressesDetails = (params = {}) => {
  return (dispatch, getState) => {
    let sourceToken = pushSourceToken("GET_DATA_TABLE_EVENT_STATS", dispatch);
    const {token} = getState().auth;
    return dispatch(actions.getEventStatsDataTable(api.fetchCongressesDetails(token,params, sourceToken)));
  };
};

export const deleteCacheForEventStats = () => {
  return (dispatch, getState) => {
    const {token} = getState().auth;
    return api.deleteCacheForEventStats(token);
  };
};

export const getCacheOldestEntryPeriodForEventStats = () => {
  return (dispatch, getState) => {
    const {token} = getState().auth;
    return api.getCacheOldestEntryPeriodForEventStats(token);
  };
};

export const fetchCycleTrainings = (cycleId, year) => {
  return (dispatch, getState) => {
    const {token, currentClient} = getState().auth;
    return api.fetchCycleTrainings(token, cycleId, currentClient.id, year);
  };
};

export const fetchBudgetData = (year, appType) => {
  return (dispatch, getState) => {
    let sourceToken = pushSourceToken("FETCH_BUDGET_DATA", dispatch);
    const {token, currentClient} = getState().auth;
    return dispatch(actions.fetchBudgetData(api.fetchBudgetData(token, currentClient.id, year, appType, sourceToken)));
  };
};

export const generateFollowUp = (appType, year, budgetPerMonth, globalTotalHTVA, globalRegistrantsCount, pricePerUnit) => {
  return (dispatch, getState) => {
    const {token, currentClient} = getState().auth;
    return dispatch(actions.generateFollowUp(api.generateFollowUp(token, currentClient.id, appType, year, budgetPerMonth, globalTotalHTVA, globalRegistrantsCount, pricePerUnit)));
  };
};

export const updateFollowUp = (annualTargetId, followUp) => {
  return (dispatch, getState) => {
    const {token} = getState().auth;
    return dispatch(actions.updateFollowUp(api.updateFollowUp(token, annualTargetId, followUp)));
  };
};

export const checkAppTypesConfiguration = (year) => {
  return (dispatch, getState) => {
    const {token, currentClient} = getState().auth;
    return dispatch(actions.checkAppTypesConfiguration(api.checkAppTypesConfiguration(token, currentClient.id, year)));
  };
};


export const deleteBudgetConfiguration = (annualTargetId, year, appType) => {
  return (dispatch, getState) => {
    const {token, currentClient} = getState().auth;
    return dispatch(actions.deleteBudgetConfiguration(api.deleteBudgetConfiguration(token, annualTargetId, currentClient.id, year, appType)));
  };
};

export const updateConfiguration = ( annualTargetId, followUp, globalRegistrantsCount, pricePerUnit ,globalTotalHTVA, budgetPerMonth) => {
  return (dispatch, getState) => {
    const {token} = getState().auth;
    return dispatch(actions.updateConfiguration(api.updateConfiguration(token, annualTargetId, followUp, globalRegistrantsCount, pricePerUnit, globalTotalHTVA, budgetPerMonth)));
  };
};

export const deleteCacheForCotisationStats = () => {
  return (dispatch, getState) => {
    const {token} = getState().auth;
    return api.deleteCacheForCotisationStats(token);
  };
}

export const getCacheOldestEntryPeriodForCotisationStats = () => {
  return (dispatch, getState) => {
    const {token} = getState().auth;
    return api.getCacheOldestEntryPeriodForCotisationStats(token);
  };
}

export const getNbrInscritsCAPaperByRegion = (period) => {
  return (dispatch, getState) => {
    const {token} = getState().auth;
    return dispatch(actions.getNbrInscritsCAPaperByRegion(api.getNbrInscritsCAPaperByRegion(token, period)));
  }
};

export const getRapportInscritsPaper = (period) => {
  return (dispatch, getState) => {
    const {token} = getState().auth;
    return dispatch(actions.getRapportInscritsPaper(api.getRapportInscritsPaper(token, period)));
  };
};

export const getRapportCAPaper = (period) => {
  return (dispatch, getState) => {
    const {token} = getState().auth;
    return dispatch(actions.getRapportCAPaper(api.getRapportCAPaper(token, period)));
  };
};

export const startCommandGetNbrCaPaperByFrequency = (period, frequency, month) => {
  return (dispatch, getState) => {    
    const {token, currentClient, user} = getState().auth;
    return dispatch(actions.startCommandGetNbrCaPaperByFrequency(api.startCommandGetNbrCaPaperByFrequency(token, period, frequency, currentClient.id, month, user.id)));
  };
}

export const startCommandGetNbrInscritBySilot = (period) => {
  return (dispatch, getState) => {    
    const {token, currentClient, user} = getState().auth;
    return dispatch(actions.startCommandGetNbrInscritBySilot(api.startCommandGetNbrInscritBySilot(token, period, currentClient.id, user.id)));
  };
}

export const startCommandGetSilotDetails = (silotId, period) => {
  return (dispatch, getState) => {    
    const {token, currentClient, user} = getState().auth;
    return dispatch(actions.startCommandGetSilotDetails(api.startCommandGetSilotDetails(token, silotId, period, currentClient.id, user.id)));
  };
}

export const getParticipantsStatsAction = () => {
  return (dispatch, getState) => {    
    const {token, currentClient, user} = getState().auth;
    return dispatch(actions.getParticipantsStatsAction(api.getParticipantsStatsAction(token, currentClient.id)));
  };
}


// WEBPACK FOOTER //
// ./app/actions/thunks/eventStats.js